import { defineStore } from "pinia";
import API from "../api/index.js";

export const useAssessmentTypesStore = defineStore('assessmentTypes', {
  state: () => ({
    assessment_types: [],
    isLoading: false,
  }),

  getters: {
    active_types: (state) => 
      state.assessment_types.filter(t => t.is_active === 1),
    
    total_max_score: (state) => 
      state.assessment_types
        .filter(t => t.is_active === 1)
        .reduce((sum, t) => sum + parseFloat(t.max_score), 0)
        .toFixed(2),
    
    sorted_types: (state) => 
      [...state.assessment_types].sort((a, b) => a.sort_order - b.sort_order)
  },

  actions: {
    async fetch_assessment_types() {
      this.isLoading = true;
      try {
        const res = await API.fetch_assessment_types();
        this.assessment_types = res.data || [];
      } catch (error) {
        console.error("Failed to fetch assessment types:", error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },

    add_to_store(new_type) {
      this.assessment_types.push(new_type);
    },

    update_in_store(updated_type) {
      const index = this.assessment_types.findIndex(t => t.id === updated_type.id);
      if (index !== -1) {
        this.assessment_types[index] = { ...this.assessment_types[index], ...updated_type };
      }
    },

    remove_from_store(id) {
      this.assessment_types = this.assessment_types.filter(t => t.id !== id);
    }
  }
});